<template><router-view /></template>
<script>
name: "layoutApp";
</script>
